import * as Sentry from "@sentry/browser";
import config from "../config";

const init = () => {
  if (config("SENTRY_ERROR_ACCESS_APP")) {
    Sentry.init({
      dsn: config("SENTRY_ERROR_ACCESS_APP"),
      environment: config("NODE_ENV")
    });
  }
};

const track = err => {
  try {
    if (config("SENTRY_ERROR_ACCESS_APP")) {
      Sentry.captureException(err);
      return;
    }
    console.error(err);
  } catch (err) {
    console.error(err);
  }
};

export default { init, track };
